import React from 'react'
import './DriversWithStatus.css'


function formatDateTime(dateTime) {
    // Rozdělíme řetězec na čas a datum
    const [time, date] = dateTime.split(' ');
    
    // Rozdělíme čas na hodiny a minuty
    const [hours, minutes] = time.split(':');
    
    // Rozdělíme datum na den, měsíc a rok
    const [day, month, year] = date.split('.');
    
    // Vytvoříme správný formát pro objekt Date: YYYY-MM-DDTHH:MM:SS
    const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}:00`;
    
    // Vytvoříme nový objekt Date
    return new Date(formattedDateTime);
  }

const timeLeft = (dateTime) => {
    const now = new Date();

    // Cílový čas (17:01 04.10.2024)
    const futureTime = new Date( formatDateTime(dateTime) );

    // Vypočítáme rozdíl v milisekundách
    const timeDifference = futureTime - now; // Rozdíl mezi budoucností a aktuálním časem

    // Převedeme milisekundy na dny, hodiny, minuty a sekundy
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
    if(hours > 0){
        return `Zbývá ${hours} hodin, ${minutes} minut.`
    } else {
  
     
        if(minutes > 0){
            return `Zbývá ${minutes} minut.`
        } else {
            return 'má zpoždění'
        }
        
    }
}


const DriversWithStatus = ({listOfDrivers, listOfOrders, setCreateOrderForDriver, whatTimeIsDriverReady}) => {

   
    
  return (
    <div>
        {listOfDrivers.map( oneDriver => {
            if(Number(oneDriver.status) > 0) {
                const driverStatus = whatTimeIsDriverReady(Number(oneDriver.id))
                return(
                    <div className='oneDriverInfoContainer' key={oneDriver.id} onClick={()=> setCreateOrderForDriver(Number(oneDriver.id)) }>
                        <div className='oneDriverInfoImage'>
                            <img src={oneDriver.img} className='avatar'/>
                        </div>
                        <div className='oneDriverInfoContent'>
                            <h4>{oneDriver.nick}</h4>
                            {driverStatus && <p style={!driverStatus? {color: 'green'} : {color: 'red' }}>má zakázku do: </p> }
                            {driverStatus && <p style={!driverStatus? {color: 'green'} : {color: 'red' }}>{driverStatus?.completionTime}</p> }
                            {driverStatus && <p style={!driverStatus? {color: 'green'} : {color: 'red' }}>{timeLeft(driverStatus?.completionTime)}</p> }
                            <h4 style={!driverStatus? {color: 'green'} : {color: 'red' }}>{!driverStatus && 'volny'}</h4>
                        </div>
                    </div>
                )

            }
        })}
       
    </div>
  )
}

export default DriversWithStatus
